import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewContainerRef,
  ChangeDetectionStrategy
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FormBuilder } from '@angular/forms';
import { SeFeFormService } from 'se-fe-form-service';
import { ChildSale } from 'src/shared/models/child-sale.model';
import { ChildSaleService } from '../../child-sale.service';
import { TrimPipe } from 'src/shared/pipes/trim.pipe';
import { ModalBaseComponent } from '../modal-base.component';

@Component({
  selector: 'app-exchange-modal',
  styleUrls: ['./exchange-modal.component.scss'],
  templateUrl: './exchange-modal.component.html',
  providers: [ TrimPipe ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ExchangeModalComponent extends ModalBaseComponent implements OnInit, OnDestroy {
  public itemsToExchange: ChildSale;

  constructor(
    viewContainerRef: ViewContainerRef,
    detector: ChangeDetectorRef,
    translate: TranslateService,
    fb: FormBuilder,
    el: ElementRef,
    fs: SeFeFormService,
    ChildSaleService: ChildSaleService
  ) {
    super(
      viewContainerRef,
      detector,
      translate,
      fb,
      el,
      fs,
      ChildSaleService);

      this.createForm();
  }


  public submitForm(): void  {
    this.submitIsInProgress = true;
    this.submitOrder();
    if (this.itemsToExchange.child_items.length > 0) {
      this.ChildSaleService.createOrder(this.itemsToExchange).subscribe(
        (response) => {
          if (!response.error || Object.keys(response.error).length === 0) {
            this.submit.emit(response.result);
            this.redirectToOrderDetail(response.result.id);
            this.cleanForm();
            this.submitIsInProgress = false;
          }
        },
        (error) => {
          this.error = true;
          this.submitIsInProgress = false;
        }
      );
      return;
    }
    this.submitIsInProgress = false;
  }


  public submitOrder(): void {
    const exchangeItems = [];
    this.selectedItems.value.forEach(item => {
      exchangeItems.push({
        item_variation_id: Number(item.item.value),
        quantity: item.quantity
      });
    });
    this.itemsToExchange = {
      parent_sale_id: this.parent_sale_id,
      consent_accepted: true,
      child_items: exchangeItems,
      notes: this.form.get('textarea').value
    };
  }
}
